import { css } from '@emotion/react';
import { DesignToken, RadiusToken, SpacingToken } from '@livechat/design-system-react-components';

import { MEDIA_MIN_SM } from '_assets/css/breakpoints';

export const container = css`
  display: flex;
  justify-content: center;
  width: auto;
  margin: var(${SpacingToken.Spacing6}) 0 0 0;
  padding: var(${SpacingToken.Spacing6}) var(${SpacingToken.Spacing4});
  background-color: var(${DesignToken.SurfacePrimaryDisabled});
  border-radius: var(${RadiusToken.Radius3});

  ${MEDIA_MIN_SM} {
    padding: var(${SpacingToken.Spacing10});
    justify-content: flex-start;
  }
`;

export const organizationsContainer = css`
  display: flex;
  flex-direction: column;
  gap: var(${SpacingToken.Spacing6});
`;

export const startNewTrial = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  gap: 4px;
  margin-top: var(${SpacingToken.Spacing3});

  ${MEDIA_MIN_SM} {
    flex-direction: row;
    padding-top: 0;
  }
`;
